import Col from './col'
import Row from './row'
let Grid = {
  Col: Col,
  Row: Row
};
export {Col, Row};
export default Grid;

